import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoveOutlined = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M9.03125 16.6562L8.96875 16.5625L3.5 11.5C2.53125 10.5938 2 9.34375 2 8.03125V7.9375C2 5.75 3.5625 3.84375 5.71875 3.4375C6.9375 3.1875 8.1875 3.46875 9.21875 4.1875C9.5 4.375 9.75 4.625 10 4.875C10.125 4.75 10.25 4.59375 10.4062 4.46875C10.5312 4.375 10.6562 4.28125 10.7812 4.1875C11.7812 3.46875 13.0312 3.1875 14.25 3.4375C16.4375 3.84375 18 5.75 18 7.9375V8.03125C18 9.34375 17.4375 10.5937 16.4688 11.5L11 16.5625L10.9375 16.6562C10.6875 16.875 10.3438 17.0312 10 17.0312C9.625 17.0312 9.3125 16.875 9.03125 16.6562ZM9.46875 6.53125C9.4375 6.53125 9.4375 6.53125 9.4375 6.5L8.875 5.875C8.15625 5.0625 7.0625 4.71875 6 4.90625C4.53125 5.1875 3.5 6.46875 3.5 7.9375V8.03125C3.5 8.9375 3.84375 9.78125 4.5 10.375L10 15.4687L15.4688 10.375C16.125 9.78125 16.5 8.9375 16.5 8.03125V7.9375C16.5 6.46875 15.4375 5.1875 13.9688 4.90625C12.9062 4.71875 11.8125 5.0625 11.0938 5.875L10.5312 6.5C10.5312 6.53125 10.5312 6.53125 10.5 6.5625C10.375 6.6875 10.1875 6.78125 10 6.78125C9.78125 6.78125 9.59375 6.6875 9.46875 6.5625V6.53125Z"
	})
});
const ForwardRef = forwardRef(SvgLoveOutlined);
export default ForwardRef;
